module.exports = __webpack_public_path__ + "static/dptlogo-0ae0969b71012bf5c19975475ec69e56.png";